module.exports = __webpack_public_path__ + "img/logo.3e0f0ffe.png";